/* 🤖 this file was generated by svg-to-ts*/
export const iconAddressBook: {
  name: 'address_book';
  data: string;
} = {
  name: 'address_book',
  data: `<svg width="32" height="32" xmlns="http://www.w3.org/2000/svg"><path d="M26.5 0c1.654 0 3 1.346 3 3v26c0 1.654-1.346 3-3 3h-19c-1.654 0-3-1.346-3-3v-1h-1a1 1 0 110-2h1v-2h-1a1 1 0 110-2h1V10h-1a1 1 0 110-2h1V6h-1a1 1 0 110-2h1V3c0-1.654 1.346-3 3-3h19zm-7 2h-12c-.552 0-1 .449-1 1v1h1a1 1 0 110 2h-1v2h1a1 1 0 110 2h-1v12h1a1 1 0 110 2h-1v2h1a1 1 0 110 2h-1v1c0 .551.448 1 1 1h19c.552 0 1-.449 1-1V3c0-.551-.448-1-1-1h-1v7a1 1 0 01-1.707.707L22.5 8.414l-1.293 1.293A1 1 0 0119.5 9V2zm5 15a1 1 0 110 2h-15a1 1 0 110-2h15zm0-4a1 1 0 110 2h-15a1 1 0 110-2h15zm-1-11h-2v4.586l.293-.293a.997.997 0 011.414 0l.293.293V2z"/></svg>`,
};
